var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoNav = function SvgLogoNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-nav_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#logo-nav_svg__b)",
    rx: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.005 19.992c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.553 4.639-2.176 15.4-4.709.077L13.553 4.64Zm0 0-9.784 6.857h4.258l-.875 6.266z"
  }))));
};
export default SvgLogoNav;